<template>
    <div id="loader">
        <div class="loader">
            <div class="spinner"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'loader'
}
</script>
<style scoped>
  /* Loader css */
  #loader{
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10000;
    transform: translateY(50%);
  }
  .loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  height: 5vh;
  width: 5vh;
  border: 6px solid rgba(0, 174, 239, 0.4);
  border-top-color: rgba(0, 174, 239, 1);
  border-radius: 100%;
  animation: rotation 0.6s infinite linear 0.25s;

  /* the opacity is used to lazyload the spinner, see animation delay */
  /* this avoid the spinner to be displayed when visible for a very short period of time */
  opacity: 0;
}

@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
</style>